// Single source of truth for the backend API base URL.
//
// All app code MUST import API_BASE_URL from here rather than reading
// process.env.REACT_APP_API_URL directly. Keeping the URL in one place
// prevents per-file drift when production URLs change and gives us one
// spot to flip dev/staging/prod if we later add environment detection.
//
// The fallback intentionally points at production: a missing env var on
// a deployed build is much worse than pointing at a real (read-only)
// production API, since the alternative is silent 404s.
const DEFAULT_API_BASE = 'https://vibana-production.up.railway.app/api';

export const API_BASE_URL = process.env.REACT_APP_API_URL || DEFAULT_API_BASE;
